import styled from 'styled-components';
import { GlobalAlert } from '@upgrade/react-components';
import { m, p } from '@upgrade/react-components/Spacing/core';

export const GlobalAlertContainer = styled(GlobalAlert)`
  position: relative;
`;

// eslint-disable-next-line import/prefer-default-export
export const StyledText = styled.p`
  ${m('none')};
  padding: 0.3rem;

  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
  line-height: 1rem;
  margin: 0 auto;
  width: 100%;

  @media (min-width: ${props => props.theme.mediaSm}) {
    ${p('sm')};
  }
  @media (min-width: ${props => props.theme.mediaMd}) {
    font-size: ${({ theme }) => theme.typography.sizes.text.desktop.sm.fontSize};
    max-width: 40%;
    line-height: 1.2rem;
  }
`;
